export default "__VITE_ASSET__CS_o$OB8__"